import React from 'react';
import './Project.css'
const Project = () => {
    return (
        <div id="project-is-one">
            <div className="marginProjectName">
               
                <h1 className="mainTextCol mb-4" style={{ color: "#fff" }}>&lt;Project&gt;</h1>
            </div>
        </div>


    );
};

export default Project;